// extracted by mini-css-extract-plugin
export default {"container":"Dinners_container__rPOWL","columnToggle":"Dinners_columnToggle__PFm00","hidden":"Dinners_hidden__TYlmG"};